import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as queryString from 'query-string';

import SportLabel from '../../../components/cards/CardComponents/SportLabel';
import { getRatingDetails, setRatingChoice } from '../../../utils';
import { colorBallDescriptions, getReturnPageName } from './constants';
import { setShowRating } from '../../../actions/onboarding-actions';

import styles from '../nuoV2.scss';
import PBRScale from '../../../components/Profile/RatingDisplayV3/PBRScale';

const ColorBallRating = (props) => {
    const { location } = props;
    const profile = useSelector(({ profile }) => profile);
    const dispatch = useDispatch();

    const parsed = queryString.parse(location.search);
    const rating = getRatingDetails(
        setRatingChoice({ player: profile.data }),
        false,
        true,
        false,
        false,
    );

    const handleNextClick = () => {
        dispatch(setShowRating(false, null));
    };

    if (profile.isLoading || !rating?.pbrRating) {
        return null;
    }

    return (
        <div className={styles.pageContent}>
            <div className={styles.title} data-testid="nuo-v2.color-ball-rating.title">
                Your estimated rating
            </div>
            <div className="row">
                <div className={`col`}>
                    <div className={styles.ratingContainer}>
                        <SportLabel sportTypeId={1} label={`CBR`} />
                        <div className={styles.rating} data-testid="nuo-v2.color-ball-rating.rating-value">{rating.pbrRating.ratingDisplay}</div>
                        <div className="mb16">
                            <PBRScale value={rating.pbrRating.value} lightBg />
                        </div>
                        <div className={styles.description} data-testid="nuo-v2.color-ball-rating.description">
                            Based on your responses, your provisional Color Ball Rating is {rating.pbrRating.ratingDisplay}. This rating is ideal for {colorBallDescriptions[rating.pbrRating.value]}. Advance your rating by playing in UTR Sports Color Ball events. See you on the court!
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <div className={styles.ratingFooter}>
                <button
                    type="button"
                    className="btn btn-primary btn-block btn-lg text-uppercase"
                    onClick={handleNextClick}
                    data-testid="nuo-v2.color-ball-rating.go-home-btn"
                >
                    {`Go ${getReturnPageName(parsed?.return)}`}
                </button>
            </div>
        </div>
    );
};

export default ColorBallRating;
